import React, {
  useEffect,
  useRef,
  useState
} from 'react';
import { Box, Grid2, Container, useMediaQuery, CircularProgress, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ScrollAnimation from '../components/ScrollAnimation';
import Footer from '../components/Footer.jsx';
import FAQ from '../components/FAQ';
import AgeVerification from '../components/AgeVerification.jsx';
import { useNavigate } from 'react-router-dom';
import './Home.css';
import { useAppContext } from '../AppContext';
import { useLocation } from 'react-router-dom';
import { useNBCUSDK } from "../context/sdk/useSDK.js"

const poster = require('../assets/httyd_banner.jpg');
const universal_logo = require('../assets/universal.png');
const httyd_logo = require('../assets/httyd_logo_small.png');
const aptos_logo = require('../assets/aptos_logo.png');


const HomePage = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false)

  const { userProfile, setUserId } = useAppContext();

  // Get SDK context
  const { sdkReady, sdkError, initializingSDK, handleOAuthLogin } = useNBCUSDK();

  // Create a ref for the FAQ section
  const targetRef = useRef(null);

  // Get the current location state
  const location = useLocation();
  const state = location.state || {};

  // Scroll to FAQ section only if the state indicates the link was clicked
  useEffect(() => {
    if (state.scrollToTarget && targetRef.current) {
      targetRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location]);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Container>
      <AgeVerification/>
      {isSmallScreen && userProfile.userId &&
        <button sx={{ fontSize: 45, marginTop: '5px' }} className="redeem-btn-fixed button-glow"
          onClick={() => navigate('/how-to-train-your-dragon/claim-card/')}>
          {/* <LocalActivityOutlinedIcon style={{marginTop: '-3px', float: 'left', paddingRight: '10px'}}/> */}
          Redeem Now
        </button>}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          flexDirection: 'row',
          justifyContent: 'space-between',
          p: 0,
          m: 0,
          mb: 2
        }}
      >
        <img
          src={httyd_logo}
          alt="Logo"
          className="logo"
          style={{ marginTop: 20 }}
          width={160}
        />
        {userProfile.userId ? (
          <Grid2 className='button-group'>
            <Grid2>
              {!isSmallScreen && <button className='redeem-btn button-glow' onClick={() => navigate('/how-to-train-your-dragon/claim-card/')}>Redeem Now</button>}
              <button className='signin-btn' onClick={() => navigate('/how-to-train-your-dragon/collection')} style={{ marginLeft: 10 }}>
                View Collection
              </button>
            </Grid2>
          </Grid2>
        ) : (
          <button className='redeem-btn' onClick={handleOAuthLogin} disabled={isLoading}>
            {isLoading ? 
              <CircularProgress color="success" size={25} style={{ margin: '0 auto', display: 'block'}}/> : "Sign-In To Redeem"
            }
          </button>
        )}
      </Box>
      {/* {authenticatedUser !== null && (
        <h2 style={{
          color: '#fff',
          wordBreak: 'break-all',
          maxWidth: '100%'
        }}>
          {JSON.stringify(authenticatedUser)}
        </h2>
      )} */}
      {/* <div className="banner-container">
                <img src={poster} className='wicked-banner' alt='Wicked Banner' />
            </div> */}
      {/* <div className='gradient-section'>
            </div> */}
      <ScrollAnimation />
      <Box style={{
        // position: 'relative',
        // marginTop: -300,
        // zIndex: 9999
      }}>
        <Typography variant="h5" style={{
          maxWidth: 600,
          margin: '0 auto',
          display: 'block',
          marginBottom: 20
        }}>
          Magic awaits - start collecting now and be the first to unlock surprises in an upcoming mobile game.
        </Typography>
        {/* <h2 style={{
          color: '#fff',
          fontWeight: 300,
          textAlign: 'center',
          width: '54%',
          display: 'block',
          margin: '0px auto 40px',
          textTransform: 'uppercase',
          lineHeight: '37px',
          // letterSpacing: '2px',
          fontSize: '26px'
        }}
          sx={{ fontSize: '13px' }}>
          Magic awaits - start collecting now and be the first to unlock surprises in an upcoming mobile game!
        </h2> */}
        {userProfile.userId ? (
          <button className='redeem-btn button-glow' onClick={() => navigate('/how-to-train-your-dragon/claim-card/')}
            style={{ display: 'block', margin: '0 auto' }}>
            Redeem Now
          </button>
        ) : (
          <button className='redeem-btn' onClick={handleOAuthLogin} disabled={isLoading}
            style={{ display: 'block', margin: '0 auto' }}>
            {isLoading ? <CircularProgress size={25} style={{ color: '#0080ff' }} /> : "Sign-In To Redeem"}
          </button>
        )}
        {/* <button className='learn-btn'>Learn more</button> */}
      </Box>
      <FAQ ref={targetRef} />
      <Footer />
    </Container>
  );
};

export default HomePage;
